import React from 'react';
import CascadeKrList from './cascade-kr-list';
import ImgIconComp from '../../../components/imgcomp';
import { withTranslation } from 'react-i18next';

class CascadeObjectiveList extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			cascadeDetailVisible: false,
			arrowImgId: 'arrow_down_blue',
		};
		this.showUpDown = this.showUpDown.bind(this);
	}

	showUpDown() {
		console.log('inside show up down');
		const { cascadeDetailVisible } = this.state;
		this.setState({ cascadeDetailVisible: !cascadeDetailVisible, arrowImgId: (cascadeDetailVisible) ? 'arrow_down_blue' : 'arrow_up_blue' });
	}

	render() {
		const { cascadeItem, t } = this.props;
		const { metric } = cascadeItem;
		const metricIds = [];
		if (metric && metric.length > 0) {
			Object.keys(metric).map((item, index) => (
				metricIds.push(metric[index].id)
			));
		}
		// console.log(this.props.setTeamObjevtiveBool  );
		return (
			<div className="cascadeUpdateListDiv">
				<div className="cascadeUpdateColRow">
					<div className="cascadeUpdateMinList cascadeUpdateColColumn">
						{`${cascadeItem.firstname} ${cascadeItem.lastname}`}
						{' '}
						{t('has cascaded')}
            			<span className="cascadeUpdateLink" onClick={() => this.showUpDown()}>
							{metric.length}
							{' '}
							{t('key result')}
              				{metric.length == 1 ? '' : 's'}
						</span>
						{' '}
						{t('to you from the objective')}
            			<span className="cascadeUpdateLink" style={{ cursor: (cascadeItem.hasAccess) ? 'pointer' : 'default' }} onClick={() => this.props.goalDetPage(cascadeItem.goalId, null, cascadeItem.hasAccess)}>{cascadeItem.goalName}</span>
						.
            			<ImgIconComp id="help_img" attr="choose_goal_cascate_help" class="goalsHelpText cascate_help" width="12" height="12" />
					</div>
					<div className="cascadeUpdateColColumn" onClick={() => this.showUpDown()}>
						<ImgIconComp id={this.state.arrowImgId} class="clickable" width="12" height="12" />
					</div>
				</div>
				<div className="cascadeUpdateColRow ">
					{
						this.state.cascadeDetailVisible
						&& (
							<div className="cascadeUpdateDetailsList">
								<div className="cascadeUpdateDetailsListDiv">
								{t('Cascaded Key Result')}
                                {metric.length == 1 ? '' : 's'}
									{' '}
									{t('Details')}:
                              </div>
								{
									metric != null && metric.length
									&& Object.keys(metric).map((item, index) => (
										<CascadeKrList cascadeKrItem={metric[index]} hasAccess={cascadeItem.hasAccess} objId={cascadeItem.goalId} cascadeObjOwner={cascadeItem.firstname} goalDetPage={this.props.goalDetPage} key={index} />
									))

								}
								<div className="cascadeUpdateSemibold cascadeObjectLink">
									{t('Set a')}
                                {
										(this.props.setTeamObjevtiveBool == 1)
										&& (
											<span>
												<span className="cascadeUpdateLink goalSetTeamGoal" data-metric-ids={metricIds.join(',')}> {t('team objective')}</span>
												{' '}
												{t('or')}
											</span>
										)
									}
									<span>
										<span className="cascadeUpdateLink goalSetIndividualGoal" data-mygoal="1" data-metric-ids={metricIds.join(',')}> {t('individual objective')}</span>
										{' '}
										{t('aligned to')}
                                  		{' '}
										{cascadeItem.firstname}'s {t('OKR to create the requested key result')}
                                  		{metric.length == 1 ? '' : 's'}
									</span>
								</div>
							</div>
						)
					}
				</div>
			</div>
		);
	}
}

export default withTranslation()(CascadeObjectiveList);